import {
  Box,
  CircularProgress,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { Bar } from "react-chartjs-2";
import {
  EstatisticasFluxo,
} from "../../../../../types/mutations/estatisticas-fluxo";
import useFormatTime from "../../../../../hooks/useFormatTime";

interface GraficoLineEstatisticaProps {
  data?: EstatisticasFluxo;
  isLoading?: boolean;
}

const DEFAULT_HEIGHT = 300;
const CHART_COLOR = "#1B5E20";

export default function GraficoLineEstatistica({
  data,
  isLoading = false
}: GraficoLineEstatisticaProps) {
  const { formatTime } = useFormatTime();

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height={DEFAULT_HEIGHT}>
        <CircularProgress />
      </Box>
    );
  }

  const tarefas = data?.estatistica?.tarefas ?? [];

  if (!tarefas.length) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height={DEFAULT_HEIGHT}>
        <Typography color="text.secondary">
          Nenhum dado disponível
        </Typography>
      </Box>
    );
  }

  const chartTasks = [...tarefas]
    .sort((a, b) => b.media_tempo - a.media_tempo)

  const chartData = {
    labels: chartTasks.map(t => t.nome_tarefa),
    datasets: [
      {
        label: "Tempo médio",
        data: chartTasks.map(t => t.media_tempo),
        backgroundColor: CHART_COLOR,
        borderRadius: 6,
        barPercentage: 0.7,
        categoryPercentage: 0.8
      }
    ]
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: "y" as const,
    layout: {
      padding: { top: 8, bottom: 8 }
    },
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: (ctx: any) => formatTime(ctx.raw)
        }
      }
    },
    scales: {
      x: {
        beginAtZero: true,
        title: {
          display: true,
          text: "Tempo médio"
        },
        ticks: {
          callback: (value: any) => formatTime(value)
        }
      },
      y: {
        grid: { display: false },
        ticks: {
          font: { size: 11 },
          autoSkip: false
        }
      }
    }
  };

  return (
    <Box>
      <Box mb={5} sx={{ minHeight: DEFAULT_HEIGHT, height: Math.max(DEFAULT_HEIGHT, chartTasks.length * 40) }}>
        <Bar data={chartData} options={chartOptions} />
      </Box>
      <TableContainer>
        <Table size="small" aria-label="a dense table">
          <TableHead sx={{ '& th': { fontWeight: 'bold', fontSize: 12 } }}>
            <TableRow>
              <TableCell align="left">Tarefa</TableCell>
              <TableCell align="right">Tempo médio</TableCell>
            </TableRow>
          </TableHead>
          <TableBody
            sx={{ '& td': { fontSize: 12 } }}
          >
            {chartTasks.map((tarefa, index) => (
              <TableRow key={index} hover>
                <TableCell>{tarefa.nome_tarefa}</TableCell>
                <TableCell align="right">
                  {formatTime(tarefa.media_tempo)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>

      </TableContainer>
    </Box >
  );
}